import moment from 'moment'

const formatDate = (app) => {

  const _formatDate = (date, dt = null) => {
    let valid = moment(date).isValid()
    let dateFomatted = ''
    if (valid) {
      if(dt){
        dateFomatted =  moment(date).format('DD-MM-YYYY HH:mm')
      } else {
        dateFomatted =  moment(date).format('DD-MM-YYYY')
      }
    } 
    return dateFomatted
  }
  

  app.config.globalProperties.$formatDate =  _formatDate
  return app

}

export {
  formatDate
}


